import { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Form, Pagination, Row, Table } from "react-bootstrap";
import { downloadMembers, getMembers } from "../../controllers/user";
import { useAuth } from "../../components/auth/AuthProvider";
import { Link, useParams } from "react-router-dom";
import { getEtapas, getOrg } from "../../controllers/org";
import { getRoles, levels } from "../../controllers/roles";
import Loading from "../../components/loading/Loading";
import { renderRoles } from "../../controllers/utils";
import MemberChangeTeamModal from "../../components/equipo/MemberChangeTeamModal";
import YearSelector from "../../components/common/YearSelector";
import useYearParam from "../../hooks/useYearParam";

/**
 * Levels:
 * - 1: nacional
 * - 2: region
 * - 3: diocesis
 * - 4: comunidad
 * - 5: equipo
 */

function Members( { preloadedMembers, comunidadId, etapaId, equipoId, showYearSelector = true }) {
  const params = useParams();
  const [ciclo, onCicloChange] = useYearParam();
  let level = 1;
  if (params.regionId) {
    level = 2;
  }
  else if (params.diocesisId) {
    level = 3;
  }
  else if (params.comunidadId) {
    level = 4;
  }
  else if (params.teamId) {
    level = 5;
  }
  const [page, setPage] = useState(0);
  const [org, setOrg] = useState();
  const [roles, setRoles] = useState();
  const [etapas, setEtapas] = useState();
  const [members, setMembers] = useState([]);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [region, setRegion] = useState(level === levels.region ? parseInt(params.regionId) : null);
  const [diocesis, setDiocesis] = useState(level === levels.diocesis ? parseInt(params.diocesisId) : null);
  const [comunidad, setComunidad] = useState(level === levels.comunidad ? parseInt(params.comunidadId) : null);
  const [equipo, setEquipo] = useState(level === levels.equipo ? parseInt(params.teamId) : null);
  const [etapa, setEtapa] = useState();
  const [role, setRole] = useState();
  const [paymentStatus, setPaymentStatus] = useState('');
  const [filterSubmitCount, setFilterSubmitCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { token, onLogout } = useAuth();
  const [showChangeTeamModalMembershipId, setShowChangeTeamModalMembershipId] = useState(0);

  useEffect(() => {
    loadMembers();
    loadOrg();
    loadRoles();
    loadEtapas();
  }, []);
  useEffect(() => {
    loadMembers();
  }, [ciclo]);
  useEffect(() => {
    if (!org) {
      return;
    }
    switch (level) {
      case levels.comunidad:
        const dId = org.comunidades.filter(c => c.comunidad_id === parseInt(params.comunidadId))[0].diocesis_id;
        const rId = org.diocesis.filter(d => d.diocesis_id === dId)[0]?.region_id;
        setRegion(rId);
        setDiocesis(dId);
        setComunidad(parseInt(params.comunidadId));
        break;

      case levels.diocesis:
        setRegion(org.diocesis.filter(d => d.diocesis_id === parseInt(params.diocesisId))[0]?.region_id);
        setDiocesis(parseInt(params.diocesisId));
        break;
    }
  }, [org]);
  useEffect(() => {
    if (!filterSubmitCount) {
      return;
    }
    loadMembers();
  }, [filterSubmitCount]);
  useEffect(() => {
    loadMembers();
  }, [page, pageSize]);
  useEffect(() => {
    if (level < levels.diocesis && !params.diocesisId) {
      setDiocesis();
    }
  }, [region]);
  useEffect(() => {
    if (level < levels.comunidad) {
      setComunidad();
    }
  }, [diocesis]);
  useEffect(() => {
    if (preloadedMembers) {
      setMembers(preloadedMembers);
      setCount(preloadedMembers.length);
    }
  }, [preloadedMembers])

  async function loadMembers () {
    if (preloadedMembers) {
      setMembers(preloadedMembers);
      setCount(preloadedMembers.length);
      return;
    }
    try {
      const d = await getMembers(token, {
        region,
        diocesis,
        comunidad,
        ciclo,
        role,
        etapa,
        paymentStatus,
        page: page,
        pageSize
      });
      setMembers(d.rows);
      setCount(d.count);
    }
    catch (e) {
      if (e.status === 401 || e.status === 403) {
        onLogout();
      }
    }
  }
  async function loadOrg(){
    let o = await getOrg();
    setOrg(o);
  }

  async function loadRoles(){
    let r = await getRoles();
    setRoles(r);
  }
  async function loadEtapas(){
    let e = await getEtapas(1);
    let e2 = await getEtapas(2);
    e.push(...e2);
    setEtapas(e);
  }

  async function download() {
    if (isDownloading) {
      return;
    }
    try {
      setIsDownloading(true);
      const d = await downloadMembers(token, {
        region,
        diocesis,
        comunidad,
        ciclo,
        role,
        etapa,
        paymentStatus
      });
      setIsDownloading(false);
    }
    catch (e) {
      setIsDownloading(false);
      if (e.status === 401 || e.status === 403) {
        onLogout();
      }
    }
  }

  function showChangeTeamModal(membership_id) {
    console.log('membership_id: ' + membership_id);
    setShowChangeTeamModalMembershipId(membership_id);
  }
  function hideModal() {
    setShowChangeTeamModalMembershipId(0);
  }

  function renderMembers() {
    const pagedMembers = preloadedMembers
      ? members.slice(page * pageSize, (page + 1) * pageSize)
      : members;

    return pagedMembers.map((m, i) => <tr key={`member-${m.user_id}-${i}`}>
      <td><Link to={`/app/members/${m.user_id}?ciclo=${ciclo}`}>{m.user.email}</Link></td>
      <td>{m.user.profile.first_name_1}</td>
      <td>{m.user.profile.first_name_2}</td>
      <td>{m.user.profile.last_name}</td>
      {!preloadedMembers && <>
      <td>{m.region.label}</td>
      <td>{m.diocesis.label}</td>
      <td>{m.comunidad.label}</td>
      <td>{renderRoles(m.membership_roles)}</td>
      </>}
      { m.order && <td>Pagado</td>}
      { !m.order && <td><span className="text-danger">No Pagado</span></td>}
      {!!preloadedMembers && level === 5 && <>
        <td><Button variant="secondary" onClick={ev => showChangeTeamModal(m.membership_id)}>Cambiar de equipo</Button></td>
      </>}
    </tr>);
  }

  function renderDiocesisOptions() {
    if (!region) {
      return [
        <option value="" key={`filter-diocesis-null`}>-- Selecciona una región --</option>
      ]
    }
    let d = org.diocesis.filter(d => d.region_id === region);
    d.unshift({ diocesis_id: '', label: '-- Selecciona una diócesis -- '});
    return d.map(d => <option value={d.diocesis_id} key={`filter-diocesis-${d.diocesis_id}`}>{d.label}</option> );
  }

  function renderComunidadOptions() {
    if (!region) {
      return [
        <option value="" key={`filter-comunidad-null-1`}>-- Selecciona una región --</option>
      ];
    }
    if (!diocesis) {
      return [
        <option value="" key={`filter-comunidad-null-2`}>-- Selecciona una diócesis --</option>
      ];
    }
    let c = org.comunidades.filter(c => c.diocesis_id === diocesis);
    c.unshift({ comunidad_id: '', label: '-- Selecciona una comunidad -- '});
    return c.map(c => <option value={c.comunidad_id} key={`filter-comunidad-${c.comunidad_id}`}>{c.label}</option> );
  }

  function onSubmit(e) {
    e.preventDefault();
    setPage(0);
    let newQ = ``;
    function addAmpersand() {
      if (newQ) {
        newQ += '&';
      }
    }
    if (region) {
      newQ += `region=${region}`;
    }
    if (diocesis) {
      addAmpersand();
      newQ += `diocesis=${diocesis}`;
    }
    if (comunidad) {
      addAmpersand();
      newQ += `comunidad=${comunidad}`;
    }
    if (role) {
      addAmpersand();
      newQ += `role=${role}`;
    }
    if (etapa) {
      addAmpersand();
      newQ += `etapa=${etapa}`;
    }
    if (paymentStatus) {
      addAmpersand();
      newQ += `paymentStatus=${paymentStatus}`;
    }
    console.log(`q: ${newQ}`);
    setFilterSubmitCount(c => c + 1);
  }

  function onClearFilters() {
    let baseRegion;
    let baseDiocesis;
    let baseComunidad;

    if (level === levels.region) {
      baseRegion = parseInt(params.regionId);
    }
    else if (level === levels.diocesis) {
      baseDiocesis = parseInt(params.diocesisId);
      baseRegion = org?.diocesis?.find(d => d.diocesis_id === baseDiocesis)?.region_id ?? region;
    }
    else if (level === levels.comunidad) {
      baseComunidad = parseInt(params.comunidadId);
      baseDiocesis = org?.comunidades?.find(c => c.comunidad_id === baseComunidad)?.diocesis_id ?? diocesis;
      baseRegion = org?.diocesis?.find(d => d.diocesis_id === baseDiocesis)?.region_id ?? region;
    }

    setRegion(level < levels.region ? undefined : baseRegion);
    setDiocesis(level < levels.diocesis ? undefined : baseDiocesis);
    setComunidad(level < levels.comunidad ? undefined : baseComunidad);
    setRole();
    setEtapa();
    setPaymentStatus('');
    setPage(0);
    setFilterSubmitCount(c => c + 1);
  }

  if (!org || !members || !etapas || !roles || isLoading) {
    return <Loading text="Cargando"></Loading>
  }

  const totalPages = Math.max(1, Math.ceil(count / pageSize));
  const currentPage = Math.min(page + 1, totalPages);

  function onPageSizeChange(e) {
    const selectedPageSize = parseInt(e.target.value);
    setPage(0);
    setPageSize(selectedPageSize);
  }

  function renderPageItems() {
    if (totalPages <= 1) {
      return null;
    }

    const maxVisible = 7;
    const pages = [];

    if (totalPages <= maxVisible) {
      for (let p = 1; p <= totalPages; p++) {
        pages.push(p);
      }
    }
    else {
      const first = 1;
      const last = totalPages;
      const current = currentPage;
      const start = Math.max(2, current - 1);
      const end = Math.min(last - 1, current + 1);

      pages.push(first);

      if (start > 2) {
        pages.push('start-ellipsis');
      }

      for (let p = start; p <= end; p++) {
        pages.push(p);
      }

      if (end < last - 1) {
        pages.push('end-ellipsis');
      }

      pages.push(last);
    }

    return pages.map((item, idx) => {
      if (typeof item === 'string') {
        return <Pagination.Ellipsis key={`ellipsis-${item}-${idx}`} disabled />;
      }
      return (
        <Pagination.Item
          key={`page-${item}`}
          active={item === currentPage}
          onClick={() => setPage(item - 1)}
        >
          {item}
        </Pagination.Item>
      );
    });
  }

  function renderPaginationControls(className = 'mt-3') {
    return (
      <Row className={className}>
        <Col className="d-flex flex-wrap align-items-center justify-content-between gap-2">
          <div>{`Mostrando ${count ? ((currentPage - 1) * pageSize) + 1 : 0}-${Math.min(currentPage * pageSize, count)} de ${count} miembros`}</div>
          <div className="d-flex align-items-center gap-2">
            <Form.Label className="mb-0">Por página</Form.Label>
            <Form.Select value={pageSize} onChange={onPageSizeChange} style={{ width: '120px' }}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
            <Pagination className="mb-0">
              <Pagination.Prev onClick={() => setPage(page - 1)} disabled={page <= 0} />
              {renderPageItems()}
              <Pagination.Next onClick={() => setPage(page + 1)} disabled={page + 1 >= totalPages} />
            </Pagination>
          </div>
        </Col>
      </Row>
    );
  }

  return <Container>
    <Row className="mb-3">
      <Col><h1>Miembros</h1></Col>
      {showYearSelector && <Col md={3} className="ms-auto">
        <YearSelector
          value={ciclo}
          onChange={onCicloChange}
          keyPrefix="filter-year"
        />
      </Col>}
    </Row>
    {
    !preloadedMembers &&
    <>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>Filtros</Accordion.Header>
          <Accordion.Body>
            <Form onSubmit={onSubmit}>
              <Row>
                {level < levels.region && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Región</Form.Label>
                    <Form.Select name='region' value={region ?? ''} onChange={e => setRegion(e.target.value ? parseInt(e.target.value) : undefined)}>
                      <option value="">-- Selecciona una región --</option>
                      { org.regiones.map(r => <option value={r.region_id} key={`filter-region-${r.region_id}`}>{r.label}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
                {level < levels.diocesis && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Diócesis</Form.Label>
                    <Form.Select name='diocesis' value={diocesis ?? ''} onChange={e => setDiocesis(e.target.value ? parseInt(e.target.value) : undefined)}>
                      { renderDiocesisOptions() }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
                {level < levels.comunidad  && <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Comunidad</Form.Label>
                    <Form.Select name='comunidad' value={comunidad ?? ''} onChange={e => setComunidad(e.target.value ? parseInt(e.target.value) : undefined)}>
                      { renderComunidadOptions() }
                    </Form.Select>
                  </Form.Group>
                </Col>
                }
              </Row>
              <Row>
              <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Apostolado</Form.Label>
                    <Form.Select name='apostolado' value={role ?? ''} onChange={e => setRole(e.target.value ? parseInt(e.target.value) : undefined)}>
                      <option value="">-- Selecciona un apostolado --</option>
                      { roles.map(r => <option value={r.role_id} key={`filter-role-${r.role_id}`}>{r.label}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nivel</Form.Label>
                    <Form.Select name='etapa' value={etapa ?? ''} onChange={e => setEtapa(e.target.value ? parseInt(e.target.value) : undefined)}>
                      <option value="">-- Selecciona un nivel --</option>
                      { etapas.map(e => <option value={e.etapa_id} key={`etapa-${e.etapa_id}`}>{e.title + (e.type === 1 ? ' - Matrimonios' : ' - MRF')}</option>) }
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Estatus de pago</Form.Label>
                    <Form.Select name='paymentStatus' value={paymentStatus} onChange={e => setPaymentStatus(e.target.value)}>
                      <option value="">-- Todos --</option>
                      <option value="paid">Pagado</option>
                      <option value="unpaid">No pagado</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={3} className="d-flex gap-2">
                  <Button type="submit" variant="primary">Filtrar</Button>
                  <Button type="button" variant="outline-secondary" onClick={onClearFilters}>Limpiar filtros</Button>
                </Col>
              </Row>
            </Form>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <Row>
        <Col className="mt-3" style={{textAlign: 'right'}}>
          <Button onClick={download}>{isDownloading ? 'Descargando...' : 'Descargar'}</Button>
        </Col>
      </Row>
    </>
    }

    {renderPaginationControls()}

    <Row>
      <Col className="table-wrapper">
        <Table striped hover className="mt-5">
          <thead>
            <tr>
              <td>Email</td>
              <td>Nombre 1</td>
              <td>Nombre 2</td>
              <td>Apellido</td>
              {!preloadedMembers && <>
              <td>Región</td>
              <td>Diócesis</td>
              <td>Comunidad</td>
              <td>Apostolado</td>
              </>}
              <td>Pagado</td>
              {!!preloadedMembers && level === 5 && <>
                <td>Administrar</td>
              </>}
            </tr>
          </thead>
          <tbody>
            {renderMembers()}
          </tbody>
        </Table>
      </Col>  
    </Row>
    {renderPaginationControls('mb-3')}
    {!!showChangeTeamModalMembershipId && 
      <MemberChangeTeamModal
        show={!!showChangeTeamModalMembershipId} 
        membershipId={showChangeTeamModalMembershipId}
        comunidadId={comunidadId}
        etapaId={etapaId}
        equipoId={equipoId}
        handleClose={hideModal}
        />
    }
  </Container>;
}

export default Members;